module.exports = __webpack_public_path__ + "assets/739143f8bdad73e54ed84002707fdb67.ttf";